import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './Previewer.scss'
import PerfectScrollbar from 'react-perfect-scrollbar'
import classnames from 'classnames'

export const Previewer = ({
  width,
  height,
  pixelRatio,
  content,
  sandbox,
  comesFromBeeModalPreview,
  'data-mu-test': dataAttributeTest
}) => {
  const [contentHeight, setContentHeight] = useState(0)
  const MAX_CONTENT_HEIGHT = 535 - (40 + 40 + 22 + 30 + 20 + 18 + 18 + 30) // somma di elementi interni la modale diversi dal contenitore della preview

  const elIframe = useRef(null)

  const { current: getContentHeight } = useRef(() => {
    setTimeout(() => {
      if (elIframe.current) {
        setContentHeight(
          elIframe.current.contentWindow.document.body.scrollHeight
        )
      }
    }, styles.mobileDisplayTransitionDuration)
  })

  const { current: scrollPerfectScrollbar } = useRef(e => {
    elIframe.current.parentElement.scrollTop += e.deltaY
  })

  useEffect(() => {
    if (elIframe.current) {
      var iframeWin = elIframe.current.contentWindow
      var iframeDoc = iframeWin.document
      iframeDoc.open()
      iframeDoc.write(content)
      iframeDoc.close()
      iframeWin.addEventListener('wheel', scrollPerfectScrollbar)

      const cleanup = () => {
        if (typeof iframeWin.removeEventListener === 'function')
          iframeWin.removeEventListener('wheel', scrollPerfectScrollbar)
      }

      return cleanup
    }
  }, [elIframe.current, content])

  useLayoutEffect(() => {
    getContentHeight()
  })

  const displayWidth = width && width / pixelRatio
  const displayHeight = height && height / pixelRatio

  return (
    <div
      className={classnames('c-previewer', {
        'c-previewer--mobile': width && height
      })}
      data-mu-test={dataAttributeTest}
    >
      <div className={classnames('c-previewer__container')}>
        <div
          className='c-previewer__display'
          style={{ width: displayWidth, height: displayHeight }}
        >
          {content && (
            <PerfectScrollbar>
              <iframe
                ref={elIframe}
                sandbox={sandbox}
                frameBorder='0'
                height={
                  comesFromBeeModalPreview &&
                  contentHeight >= MAX_CONTENT_HEIGHT
                    ? MAX_CONTENT_HEIGHT
                    : contentHeight
                }
                scrolling={
                  comesFromBeeModalPreview &&
                  contentHeight >= MAX_CONTENT_HEIGHT
                    ? 'yes'
                    : 'no'
                }
                onLoad={getContentHeight}
                data-mu-test='previewer__iframe'
              />
            </PerfectScrollbar>
          )}
        </div>
      </div>
    </div>
  )
}
Previewer.defaultProps = {
  sandbox: 'allow-same-origin'
}

Previewer.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  pixelRatio: PropTypes.number,
  content: PropTypes.any,
  sandbox: PropTypes.string,
  comesFromBeeModalPreview: PropTypes.bool,
  'data-mu-test': PropTypes.string
}
